import { space } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.js';
import { style } from '@vanilla-extract/css';

export const settingsContainer = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s20,
});

export const settingGroup = style({
  display: 'flex',
  flexDirection: 'column',
});

export const settingLabel = style([
  typography.bodyMd,
  {
    display: 'block',
    marginBottom: space.s8,
  },
]);

export const switchGroup = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: space.s12,
});

export const switchLabel = style([
  typography.bodyMd,
  {
    flex: 1,
  },
]);

export const expandableSwitchGroupLabel = style([
  typography.bodyMd,
  {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    cursor: 'pointer',
    gap: space.s12,
  },
]);

export const highlightSoundSection = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s12,
  marginTop: space.s16,
});
